import { gql } from '@apollo/client';

const Fragments = {
  metadata: gql`
    fragment metadata on Metadata {
      id
      code
      name
      dataType
      entityType
    }
  `
};

export default Fragments;
